/* Navbar Shop menu and the phone drawer, on every page (27 Sep 2026).

   Shop opens a panel of three product cards (Combo, Mornings, Nights), her
   ask after IM8's menu. Click toggles it; on a mouse, hovering opens it too,
   and a click that lands within 600ms of a hover-open keeps it open rather
   than toggling it shut under the pointer. Escape, a click outside, or
   leaving both trigger and panel close it. The trigger's href is the
   all-products page, so modified clicks and no-JS still navigate.

   The drawer part exists because drinksilt-header.js, which owns the phone
   drawer, loads on the homepage only: on every other page the hamburger did
   nothing. Opening and closing are idempotent, so on the homepage both files
   binding the same buttons is harmless. */
(function () {
  var header = document.querySelector('[data-drinksilt-header]');
  if (!header || header.dataset.siltShopMenu === 'on') return;
  header.dataset.siltShopMenu = 'on';

  /* ---- desktop dropdown ------------------------------------------------ */
  var trigger = header.querySelector('[data-silt-shop-trigger]');
  var panel = header.querySelector('[data-silt-shop-menu]');
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
  var openedByHoverAt = 0;
  var closeTimer = null;
  var openTimer = null;

  function isOpen() { return trigger && trigger.getAttribute('aria-expanded') === 'true'; }

  function open(byHover) {
    if (!trigger || !panel) return;
    clearTimeout(closeTimer);
    if (isOpen()) return;
    panel.hidden = false;
    /* next frame, so the transition runs from the hidden state */
    requestAnimationFrame(function () { panel.classList.add('is-open'); });
    trigger.setAttribute('aria-expanded', 'true');
    header.classList.add('has-shop-open');
    if (byHover) openedByHoverAt = Date.now();
  }

  function close(returnFocus) {
    if (!trigger || !panel || !isOpen()) return;
    clearTimeout(openTimer);
    panel.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');
    header.classList.remove('has-shop-open');
    setTimeout(function () { if (!isOpen()) panel.hidden = true; }, 220);
    if (returnFocus) trigger.focus();
  }

  if (trigger && panel) {
    trigger.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      if (isOpen()) {
        if (Date.now() - openedByHoverAt < 600) return;
        close(false);
      } else {
        open(false);
        /* keyboard users land in the panel, not on Science */
        if (e.detail === 0) {
          var first = panel.querySelector('a');
          if (first) first.focus();
        }
      }
    });

    function hoverIn() {
      if (!hoverable.matches) return;
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(true); }, 90);
    }
    function hoverOut() {
      if (!hoverable.matches) return;
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { close(false); }, 240);
    }
    trigger.addEventListener('mouseenter', hoverIn);
    trigger.addEventListener('mouseleave', hoverOut);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', hoverOut);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) close(true);
    });
    document.addEventListener('click', function (e) {
      if (!isOpen()) return;
      if (panel.contains(e.target) || trigger.contains(e.target)) return;
      close(false);
    });
    panel.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !panel.contains(e.relatedTarget) && e.relatedTarget !== trigger) close(false);
    });
  }

  /* ---- phone drawer ---------------------------------------------------- */
  var drawer = header.querySelector('[data-drinksilt-menu-drawer]');
  var openButtons = header.querySelectorAll('[data-drinksilt-menu-open]');
  var closeButtons = header.querySelectorAll('[data-drinksilt-menu-close]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  openButtons.forEach(function (b) { b.addEventListener('click', openDrawer); });
  closeButtons.forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeDrawer); });
  }

  /* Shop inside the drawer: collapsed by default (her 10 Oct call), opens on tap. */
  var mToggle = header.querySelector('[data-silt-shop-m-toggle]');
  if (mToggle) {
    mToggle.addEventListener('click', function () {
      var expanded = mToggle.getAttribute('aria-expanded') === 'true';
      mToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var body = document.getElementById(mToggle.getAttribute('aria-controls'));
      if (body) body.hidden = expanded;
    });
  }
})();
